import { CSSProperties } from "react";

export default class PaginatedDialogViewStyle {

    paginatedDialog : CSSProperties = {
        minHeight : 480,
        width : 570,
        borderRadius : 8,
        backgroundColor : '#fff',
        overflow : 'hidden',
        display : "flex",
        flexDirection : 'column',
        marginBottom: 37.5
    }

    content : CSSProperties = {
        flex : 1,
        padding : 30,
        paddingTop: 10,
        display : "flex",
        flexDirection : "column"
    }
}